skrilla.controller('marketPlaceCtrl', function ($scope) {
    $scope.key = "marketPlace";
    $scope.tabs = [
        {title: "Offers", active: true},
        {title: "Items", active: false},
        {title: "Purchases", active: false}
    ];
});